import { CmsReactionButton } from './CmsReactionButton';
import {
  CmsReactionsContainer,
  CmsReactionsWrapper,
} from './CmsReactions.styled';
import { useCmsReactions } from './useCmsReactions';

type Props = { contentId: string };

export function CmsReactions({ contentId }: Props) {
  const { reactionType, setReactionType } = useCmsReactions(contentId);

  return (
    <CmsReactionsContainer data-qa-id="cms-reactions">
      <CmsReactionsWrapper>
        <CmsReactionButton
          contentId={contentId}
          reactionType={reactionType}
          setReactionType={setReactionType}
        />
      </CmsReactionsWrapper>
    </CmsReactionsContainer>
  );
}
